import './App.css';
import Menu from './components/Menu';

function App() {
  return (
    <>
    <Menu />
    </>
  );
}

export default App;
